import * as React from 'react'
import Milliseconds from '../../helper/milliseconds'

interface Props {
    message?: {
        args: {
            wt: number
        }
    }
}

export default class WaitForCpu extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let time = <div></div>
        if (message) {
            time = <Milliseconds value={message.args.wt} />
        }

        return (
            <div>
                <p>
                    We observed Traces with significant time {time} waiting for CPU scheduling. This happens when too many PHP processes are
                    running in parallel and not enough CPU cores can handle them. Its either a sign of webserver misconfiguration or of the
                    server being too small.
                </p>
            </div>
        )
    }
}
